<template>
  <el-container>
  
    <el-main v-if="venue">
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="12">
         <el-card class="box-card">

           <h5>Details</h5>     

          <el-form ref="form" :model="venue" label-width="120px">
            <el-row>
            <el-form-item label="Name">
              <el-input v-model="venue.name"></el-input>
            </el-form-item>
              <el-form-item label="Address">
              <el-input style="margin-bottom:10px" v-model="venue.line1"></el-input>
              <el-input v-model="venue.line2"></el-input>
            </el-form-item>
            <el-form-item label="Country" prop="country">
                  <el-select v-model="venue.country" placeholder="Country">
                    <el-option
                      v-for="(country,index) in countries"
                      class="select-default"
                      :value="country"
                      :label="index"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
            <el-form-item label="Region">
              <el-input v-model="venue.region"></el-input>
            </el-form-item>
            <el-form-item label="City">
              <el-input v-model="venue.town"></el-input>
            </el-form-item>
            <el-form-item label="Postcode">
              <el-input v-model="venue.postcode"></el-input>
            </el-form-item>
            <el-form-item label="Phone">
              <el-input v-model="venue.phone"></el-input>
            </el-form-item>
            <el-form-item label="Fax">
              <el-input v-model="venue.fax"></el-input>
            </el-form-item>
            <el-form-item label="Email">
              <el-input v-model="venue.email"></el-input>
            </el-form-item>
            <el-form-item label="Contact Name">
              <el-input v-model="venue.contactName"></el-input>
            </el-form-item>
            <el-form-item label="Website">
              <el-input v-model="venue.website"></el-input><a :href="venue.website" target="_blank"><i class="fa fa-external-link"></i></a>
            </el-form-item>
            <el-form-item label="Lat">
              <el-input v-model="venue.lat"></el-input>
            </el-form-item>
            <el-form-item label="Long">
              <el-input v-model="venue.long"></el-input>
            </el-form-item>
            <el-form-item>
              <p>You can get the lat and long by clicking <a href="https://www.latlong.net/convert-address-to-lat-long.html" target="_blank">here</a></p>
            </el-form-item>
            <el-form-item label="Active">
              <el-checkbox v-model="checked"></el-checkbox>
            </el-form-item>
            <el-form-item>
            <el-button style="float: right;margin-left:5px " type="primary" @click="updateVenue()">Update</el-button>
              <el-button style="float: right; " type="danger" @click="deleteVenue">Delete</el-button>
            </el-form-item>                   
            </el-row>
            </el-form>

        </el-card>

      </el-col>
      <el-col>

        <el-row style="margin-bottom:30px;">
          <el-card class="box-card">
            <h5>Notes:</h5>
            <div v-for='(note,index) in notes' :key='index'>
              
              <div class="col-xs-11">
                
                <div v-html="note.detail">{{note.detail}}</div><br/>
                <H6 class="text-muted" style="font-weight:400">
                  <i class="ti-time"></i> Added By
                  <span class="text-danger">{{note.updatedById | userById()}}</span> - {{note.dateCreated | moment("from", "now")}}</H6>
                <br/>
                
                <hr />
              </div>

              <div class="col-xs-1">
                <div class="btn btn-danger btn-sm btn-ws" @click="deleteNote(index)">
                  
                  <i class="fa fa-close"></i>
                </div>
              </div>

            </div>

          </el-card>
        </el-row>
        <el-row style="margin-bottom:30px;"> 
          <el-card class="box-card">
            <h5>Add Note</h5>
            <VuePellEditor 
              v-model="venueNotes.detail"
              :style-with-css="false"
              default-paragraph-separator="p"
            />
            <br />
            <el-button style="float: right;margin-left:5px " type="primary" @click="createVenueNote()">Add Note</el-button>
            <br />
            <br />
          </el-card>
         </el-row>

         <el-row>
          <el-card class="box-card">

            <h5>Letter Text</h5>      
            <VuePellEditor
              v-model="venue.letterText" 
              :style-with-css="false"
              style="white-space: pre-wrap"
              default-paragraph-separator="p"
            />
            <br />
            <el-button style="float: right;margin-left:5px " type="primary" @click="updateVenue()" >Update</el-button>
            <br />
            <br />

          </el-card>
         </el-row>

      </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
import { commonApi } from "../../api/common.js";
import json from "../../data/countries.json";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
import VuePellEditor from 'vue-pell-editor';
export default {

  data() {
    return {
     form:{},
     venue:{},
     countries: json,
     venueNotes: {
        dateCreated: moment().format(),
        dateUpdated: moment().format(),
        venueId: "",
        detail: "",
        updatedBy: "",
        createdBy: "",
      },
     checked: "",
     notes:{}
    
    };
  },
  components: {
    VuePellEditor
  },


  methods: {
  getVenue(id){
    this.$apollo
        .query({
          query: gql`
            {
              ClassRoomVenue_by_pk(id: "${id}") {
                name
                line1
                line2
                town
                postcode
                email
                website
                letterText
                historic
                country
                region
                phone
                notes{
                  id
                  detail
                }
                fax
                contactName
                lat
                long
                id
              }
            }
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.venue = response.data.ClassRoomVenue_by_pk;
          this.checked = !this.venue.historic;
      });
  },

    getVenueNotes(id){
    this.$apollo
        .query({

          query: gql`
            {
            VenueNote(order_by: {dateCreated: desc_nulls_last}, where: {venueId: {_eq: "${id}"}}) {
              detail
              id
              dateCreated
              dateUpdated
              updatedBy
              createdBy
            }
          }
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.notes = response.data.VenueNote;
      });
  },

  updateVenue(id){
          const q = gql`
            mutation update_venue($id: Int, $name: String, $line1: String, $line2: String, $town: String, $email: String, $website: String, $letterText: String, $historic: smallint, $country: String, $region: String, $postcode: String, $phone: String, $fax: String, $contactName: String, $lat: float8, $long: float8){
              update_ClassRoomVenue(where: {id: {_eq: $id}}, _set: {name: $name, line1: $line1, line2: $line2, town: $town, email: $email, website: $website, letterText: $letterText, historic: $historic, country: $country, region: $region, postcode: $postcode, phone: $phone, fax: $fax, contactName: $contactName, lat: $lat, long: $long}) {
                affected_rows
                returning {
                  name
                  line1
                  line2
                  town
                  email
                  website
                  letterText
                  historic
                  country
                  region
                  postcode
                  phone
                  fax
                  contactName
                  lat
                  long
                }
              }
            }

          `

          this.$apollo

        .mutate({
          mutation: q,
          variables: {
            id: this.venue.id,
            name: this.venue.name,
            line1: this.venue.line1,
            line2: this.venue.line2,
            town: this.venue.town,
            postcode: this.venue.postcode,
            email: this.venue.email,
            website: this.venue.website,
            letterText: this.venue.letterText,
            historic:  !this.checked ? 1 : 0,
            country: this.venue.country,
            region: this.venue.region,
            postcode: this.venue.postcode,
            phone: this.venue.phone,
            fax: this.venue.fax,
            contactName: this.venue.contactName,
            lat: this.venue.lat,
            long: this.venue.long
          }
        })



        .then(result => {
          this.$notify({
            title: "Update Venue",
            message: "Venue Updated",
            type: "success"
          });
          // return result
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });

  },

  createVenueNote() {
          
          
            const q = gql`
            mutation insert_venuenote(
              $dateCreated: date,
              $dateUpdated: date,
              $venueId: Int,
              $detail: String,
              $updatedBy: String,
              $createdBy: String
            ) {
              insert_VenueNote(objects: {
                dateCreated: $dateCreated,
                dateUpdated: $dateUpdated,
                venueId: $venueId,
                detail: $detail,
                updatedBy: $updatedBy,
                createdBy: $createdBy 
              }) {
                affected_rows
                returning {
                  id
                  detail
                }
              }
            }

            `

            this.$apollo

            .mutate({
              mutation: q,
              variables: {
                dateCreated: this.venueNotes.dateCreated,
                dateUpdated: this.venueNotes.dateUpdated,
                venueId: this.venue.id,
                detail: this.venueNotes.detail,
                updatedBy: this.venueNotes.updatedBy,
                createdBy: this.venueNotes.createdBy
              }
            })

            .then(result => {
              this.getVenueNotes(this.$route.params.id);
              this.$notify({
                title: "Create new note",
                message: "Note created",
                type: "success"
              })
            })
            .catch(error => {
              this.$notify({
                title: "Error",
                message: error.message,
                type: "error"
              })
            })

        },

        deleteNote(index){
          const q = gql`
            mutation delete_VenueNote($id: Int) { 
              delete_VenueNote(where: {id: {_eq: $id}}) {
                affected_rows
                returning {
                  id
                }
              }
            }
          `

          this.$apollo

            .mutate({
              mutation: q,
              variables: {
                id: this.notes[index].id
              }
            })

          .then(result => {
            this.getVenueNotes(this.$route.params.id);
            this.$notify({
              title: "Delete the note",
              message: "Note Deleted",
              type: "success"
            })
          })
        },
  
  deleteVenue(){
      const deleteVenue = api.deleteVenue(this.venue.id);
    Promise.resolve(deleteVenue).then(response => {
   
       ///go back to venue list
      });
  }
     
  },
  mounted() {
    this.getVenue(this.$route.params.id);
    this.getVenueNotes(this.$route.params.id);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Classrooms/VenueEdit.vue